export default __webpack_public_path__ + "static/media/me.694bebd7.jpg";